export function isBrowser(): boolean {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

export function isInIframe(): boolean {
  if (!isBrowser()) return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
